import { render, staticRenderFns } from "./itso_register_form.vue?vue&type=template&id=372271d4&"
import script from "./itso_register_form.vue?vue&type=script&lang=js&"
export * from "./itso_register_form.vue?vue&type=script&lang=js&"
import style0 from "./itso_register_form.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports